/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Agenda from './Agenda/index'
import Checkout from './Checkout/index'
import React from 'react'
import Waiting from './Waiting/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 id="agenda-sidebar"
 style={{'--tx-1-Z1Yf8zk': isBefore ? "-20px" : "0px",'--p-3-Z1Yf8zk': isMedia.mobile ? "absolute" : "relative",'--h-4-Z1Yf8zk': isMedia.mobile ? "100%" : "auto",'--w-5-Z1Yf8zk': isMedia.mobile ? "98%" : "auto",'--mr-2-Z1Yf8zk': isMedia.mobile ? "0px" : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--zi-6-Z1Yf8zk': isMedia.mobile ? 1000 : 10}}
 className={`views-block ${styles.Vertical}`}
>
<Agenda
  viewPath={`${viewPath}/Agenda`}
/>
<Waiting
  viewPath={`${viewPath}/Waiting`}
/>
<Checkout
  viewPath={`${viewPath}/Checkout`}
/>
</div>
{children}
</React.Fragment>)
}